import { Check } from "lucide-react";

const STEPS = [
  { key: "upload", n: 1, label: "Upload Actual Data" },
  { key: "assumptions", n: 2, label: "Assumptions & Variables" },
  { key: "results", n: 3, label: "Budget Results" },
  { key: "performance", n: 4, label: "Performance & Action Plan" },
  { key: "tracking", n: 5, label: "Budget vs Actual & Rolling Forecast" },
];

export const Stepper = ({ current, done, onSelect, hide = [] }) => {
  const steps = STEPS.filter((s) => !hide.includes(s.key)).map((s, i) => ({ ...s, n: i + 1 }));
  return (
  <ol className="flex flex-wrap items-center gap-x-2 gap-y-2 sm:gap-x-3" data-testid="project-stepper">
    {steps.map((s, i) => {
      const isDone = done.includes(s.key);
      const active = current === s.key;
      const enabled = isDone || active || done.includes(steps[i - 1]?.key) || (["performance", "tracking"].includes(s.key) && done.includes("results"));
      return (
        <li key={s.key} className="flex items-center gap-2 sm:gap-3">
          <button disabled={!enabled} onClick={() => onSelect(s.key)} data-testid={`step-${s.key}`}
            className={`flex items-center gap-2 text-sm font-medium transition-colors disabled:opacity-40 ${active ? "text-slate-900" : "text-slate-500 hover:text-slate-800"}`}>
            <span className={`h-7 w-7 rounded-full grid place-items-center text-xs font-mono border ${active ? "bg-slate-900 text-white border-slate-900" : isDone ? "bg-emerald-600 text-white border-emerald-600" : "bg-white border-slate-300"}`}>
              {isDone && !active ? <Check size={14} /> : s.n}
            </span>
            <span className="whitespace-nowrap">{s.label}</span>
          </button>
          {i < steps.length - 1 && <span className="h-px w-4 sm:w-8 bg-slate-300 hidden sm:block" />}
        </li>
      );
    })}
  </ol>
  );
};
